/* global axios */
import ApiClient from './ApiClient';

class ProjectBaselines extends ApiClient {
  constructor() {
    super('baselines', { accountScoped: true });
    this.projectId = null;
  }

  get url() {
    return `${this.baseUrl()}/projects/${this.projectId}/baselines`;
  }

  get(projectId) {
    this.projectId = projectId;
    return super.get();
  }

  show(projectId, id) {
    this.projectId = projectId;
    return super.show(id);
  }

  create(projectId, data) {
    this.projectId = projectId;
    return super.create({ baseline: data });
  }

  activate(projectId, id) {
    this.projectId = projectId;
    return axios.post(`${this.url}/${id}/activate`);
  }

  delete(projectId, id) {
    this.projectId = projectId;
    return super.delete(id);
  }
}

export default new ProjectBaselines();
